import { gridHeaderHeight, gridFooterHeight, gridRowHeight } from './constants';
export var getRowsPerPage = function (ref) {
    var _a;
    var containerHeight = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
    if (containerHeight) {
        return Math.floor((containerHeight - gridHeaderHeight - gridFooterHeight) / gridRowHeight);
    }
    return 0;
};
